import styled from 'styled-components';
import { Typography } from '@mui/material';

import LoadingPage from '../../../../../../components/LoadingPage';

const StyledLoadingPage = styled(LoadingPage)`
  height: 100px;
`;

const ContentText = styled(Typography)`
  font-size: 14px;
`;

const ActivityContainer = styled.div`
  padding: 20px 15px;
`;

export {
  StyledLoadingPage,
  ContentText,
  ActivityContainer,
};
